import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

function InfoMessage() {
    const { t } = useTranslation();
    const message = useSelector(state => state.Auth.message);
    const apiMessage = useSelector(state => state.API.message);
    const messages = {
        "PASSWORD_RESET": t('message-password-reset'),
        "PASSWORD_RESET_SUCCESS": t('message-password-reset-success'),
    }

    return (
        <>
            {message &&
                <div className="alert alert-success" role="alert">
                    {message && messages[message] ? messages[message] : message.toString()}
                </div>
            }
            {apiMessage &&
                <div className="alert alert-success" role="alert">
                    {apiMessage && messages[apiMessage] ? messages[apiMessage] : apiMessage.toString()}
                </div>
            }
        </>
    );
}

export default InfoMessage;
